import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { ServiceCard } from "@/components/ServiceCard";
import { CtaBand } from "@/components/CtaBand";
import { SERVICES } from "@/data/services";
import { container, sectionPad, btnPrimary } from "@/lib/ui";
import { BUSINESS, telLink } from "@/data/business";
import { breadcrumbSchema, localBusinessSchema } from "@/lib/schema";

export default function ServicesPage() {
  return (
    <>
      <Seo
        title="Cleaning Services Melbourne — Regular, Deep & End of Lease"
        description="Explore our full range of residential cleaning services in Melbourne — regular, weekly, deep, move-out, end-of-lease, apartment, Airbnb, kitchen, bathroom & more. Free quotes."
        path="/services"
        schema={[localBusinessSchema(), breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]}
      />
      <PageHeader
        eyebrow="Our Services"
        title="Residential cleaning services in Melbourne"
        subtitle="Choose the clean your home needs — every service is tailored to you and backed by a free, no-obligation quote."
        crumbs={[{ name: "Services" }]}
      >
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/quote" className={btnPrimary} data-testid="services-hero-quote">
            Get a Free Quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a href={telLink} className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 px-7 py-3.5 font-semibold text-white hover:bg-white hover:text-navy transition-colors">
            <Phone className="w-4 h-4" /> Call {BUSINESS.phoneDisplay}
          </a>
        </div>
      </PageHeader>

      <section className={`${sectionPad} bg-white`}>
        <div className={container}>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
